<template>
  <w-sliding-popup type="setting" ref="slidingPopup" :title="popupTitle" width="1500px" @close="close()">
    <div slot="content">
      <el-row type="flex" justify="space-between">
        <el-col :span="12" class="mr-r20">
          <el-row class="title-bar" type="flex" justify="space-between">
            <div class="vertical-center-box">
              <div class="title-h4 mr-r15">작업 태스크 목록</div>
              <div class="setting-addel">
                <el-button size="mini" @click="onClickAddButton('task')"><i class="fas fa-plus"></i></el-button>
                <el-button size="mini" :disabled="!checkedRows.task.length" @click="onDeleteButtonClick('task')"><i class="fas fa-minus"></i></el-button>
              </div>
            </div>
            <div class="vertical-center-box" align="right">
              <w-header-search-button size="mini" @click="showTaskSearchTool = !showTaskSearchTool"></w-header-search-button>
            </div>
          </el-row>
          <el-table-wrapper ref="taskTable" :column-default="columnDefault" :data="taskData" :columns="tableColumns.task"
          :show-search-tool="showTaskSearchTool" :show-custom-header="true" row-class-name="c-dblclick" remote pagination :total="total.task"
          @row-dblclick="onRowDblClick('task', ...arguments)" @selection-change="onSelectionChange('task', ...arguments)" @condition-change="loadData('task')">
          </el-table-wrapper>
        </el-col>
        <el-col :span="12">
          <el-row class="title-bar" type="flex" justify="space-between">
            <div class="vertical-center-box">
              <div class="title-h4 mr-r15">플랫폼 목록</div>
              <div class="setting-addel">
                <el-button size="mini" @click="onClickAddButton('nodetype')"><i class="fas fa-plus"></i></el-button>
                <el-button size="mini" :disabled="!checkedRows.nodetype.length" @click="onDeleteButtonClick('nodetype')"><i class="fas fa-minus"></i></el-button>
              </div>
            </div>
            <div class="vertical-center-box" align="right">
              <w-header-search-button size="mini" @click="showNodetypeSearchTool = !showNodetypeSearchTool"></w-header-search-button>
            </div>
          </el-row>
          <el-table-wrapper ref="nodetypeTable" :column-default="columnDefault" :data="nodetypeData" :columns="tableColumns.nodetype"
          :show-search-tool="showNodetypeSearchTool" :show-custom-header="true" row-class-name="c-dblclick" remote pagination :total="total.nodetype"
          @row-dblclick="onRowDblClick('nodetype', ...arguments)" @selection-change="onSelectionChange('nodetype', ...arguments)" @condition-change="loadData('nodetype')">
          </el-table-wrapper>
        </el-col>
      </el-row>
      <w-job-task-setting-popup :selected-job="selectedJob" :selected-task="selectedTarget.task" @re-load="loadData('task')" ref="taskSettingPopup"></w-job-task-setting-popup>
      <w-job-nodetype-setting-popup :selected-job="selectedJob" :selected-nodetype="selectedTarget.nodetype" @re-load="loadData('nodetype')" ref="nodetypeSettingPopup"></w-job-nodetype-setting-popup>
    </div>
  </w-sliding-popup>
</template>

<script>
import { isNil, camelCase } from 'lodash';
import { getValueAfterCheckEmpty, EMPTY_TEXT } from '@/utils/string';
import msgUtil from '@/utils/message';
import { columnDefault } from '@/constants/table';
import amsSettingsApi from '@/api/settings/server/ams-settings';
import WJobTaskSettingPopup from './JobTaskSettingPopup';
import WJobNodetypeSettingPopup from './JobNodetypeSettingPopup';

const defaultFormatter = (row, column, value) => getValueAfterCheckEmpty(value);
const nodeFormatter = (row, column, value) => {
  const nodetypeId = column.property;
  let cellValue = '';
  if (!isNil(row[`${nodetypeId}Name`])) {
    cellValue = row[`${nodetypeId}Name`];
  } else if (value === 'all') {
    cellValue = '전체';
  }
  return defaultFormatter(row, column, cellValue);
};

export default {
  name: 'WJobDetailListView',
  components: {
    WJobTaskSettingPopup,
    WJobNodetypeSettingPopup,
  },
  props: {
    selectedJob: {
      type: Object,
      default: () => ({ jobName: EMPTY_TEXT }),
    },
  },
  data() {
    return {
      columnDefault,
      total: {
        task: 0,
        nodetype: 0,
      },
      showTaskSearchTool: false,
      showNodetypeSearchTool: false,
      tableColumns: {
        task: [
          { type: 'selection' },
          { prop: 'taskId', label: '태스크 아이디', remoteProp: 'ajt.task_id', searchable: true, sortable: true },
          { prop: 'taskName', label: '태스크 이름', remoteProp: 'task.task_name', searchable: true, sortable: true, formatter: defaultFormatter },
          { prop: 'executeIndex', label: '수행 순서', width: 80, formatter: defaultFormatter },
        ],
        nodetype: [
          { type: 'selection' },
          { prop: 'os', label: 'OS', searchable: true, sortable: true, formatter: nodeFormatter },
          { prop: 'distributor', label: '공급자', searchable: true, sortable: true, formatter: nodeFormatter },
          { prop: 'version', label: '버전', searchable: true, sortable: true, formatter: nodeFormatter },
          { prop: 'arch', label: '아키텍처', searchable: true, sortable: true, formatter: nodeFormatter },
        ],
      },
      taskData: [],
      nodetypeData: [],
      selectedTarget: {
        task: null,
        nodetype: null,
      },
      checkedRows: {
        task: [],
        nodetype: [],
      },
    };
  },
  computed: {
    popupTitle() {
      const selectedJob = this.selectedJob;
      return isNil(selectedJob) ? '' : `${selectedJob.jobName} 작업`;
    },
  },
  methods: {
    open() {
      this.$refs.slidingPopup.visible = true;
      this.$nextTick(() => {
        this.loadData();
      });
    },
    close() {
      this.$refs.slidingPopup.visible = false;
      this.showTaskSearchTool = false;
      this.showNodetypeSearchTool = false;
      this.$refs.taskTable.clearFilter();
      this.$refs.nodetypeTable.clearFilter();
      this.$refs.taskTable.getTable().clearSelection();
      this.$refs.nodetypeTable.getTable().clearSelection();
    },
    loadData(targetType) {
      if (isNil(targetType) || targetType === 'task') {
        const tableParams = this.$refs.taskTable.getParameter();
        amsSettingsApi.getJobTaskList({ jobId: this.selectedJob.jobId, ...tableParams }).then((response) => {
          if (response.data.success) {
            this.taskData = response.data.data;
            this.total.task = response.data.total;
          }
        });
      }
      if (isNil(targetType) || targetType === 'nodetype') {
        const tableParams = this.$refs.nodetypeTable.getParameter();
        amsSettingsApi.getJobNodetypeList({ jobId: this.selectedJob.jobId, ...tableParams }).then((response) => {
          if (response.data.success) {
            this.nodetypeData = response.data.data;
            this.total.nodetype = response.data.total;
          }
        });
      }
    },
    /**
     * 추가 버튼 클릭
     * @author jeee12
     * @param  {[type]} targetType task 또는 nodetype
     */
    onClickAddButton(targetType) {
      this.selectedTarget[targetType] = null;
      this.$nextTick(() => {
        this.$refs[`${targetType}SettingPopup`].open();
      });
    },
    /**
     * row 더블 클릭
     * @author jeee12
     * @param  {[type]} targetType task 또는 nodetype
     * @param  {[type]} row        [description]
     */
    onRowDblClick(targetType, row) {
      this.selectedTarget[targetType] = row;
      this.$nextTick(() => {
        this.$refs[`${targetType}SettingPopup`].open();
      });
    },
    onSelectionChange(targetType, selection) {
      this.checkedRows[targetType] = selection;
    },
    /**
     * 삭제 버튼 클릭
     * @author jeee12
     * @param  {[type]} targetType 삭제할 대상
     * @return {[type]}            [description]
     */
    onDeleteButtonClick(targetType) {
      this.$confirm(...msgUtil.getBasicConfirmData(msgUtil.action.DELETE)).then(() => {
        const target = targetType === 'task' ? '작업 태스크' : '플랫폼';
        const action = msgUtil.action.DELETE;
        amsSettingsApi[camelCase(`deleteJob_${targetType}_list`)](this.checkedRows[targetType]).then((response) => {
          if (response.data.success) {
            this.loadData(targetType);
          }
          this.$message(msgUtil.getResultMsgData(action, target, response.data.success));
        }).catch(() => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        });
      }).catch(() => {});
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/server/AmsSettings/JobSetting/popup/JobDetailListPopup.vue